import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { BoilersEffects, boilersReducer, boilersSelectorKey } from './store';

@NgModule({
  imports: [
    StoreModule.forFeature(boilersSelectorKey, boilersReducer),
    EffectsModule.forFeature([BoilersEffects]),
  ],
})
export class BoilersBootstrapModule {}
